// External Libraries
import React, { useMemo } from 'react'

// Internal Modules
// Global Utilities and Constants
import { createDocuments } from '@/utils/documentsUtils'

// Components
import DataTable from '@/components/Table/data-table'
import { DataTableToolbar } from '@/components/ManageDocuments/table/data-table-toolbar'
import { CoursesTableSkeleton } from '@/components/Skeletons/CoursesTableSkeleton'

// Columns for DataTable
import columns from '@/components/ManageDocuments/table/columns'

// Hooks and Jotai Atoms
import useAllCourseDocuments from '@/hooks/documents/useAllCourseDocuments'
//

export default function ManageDocuments() {
   let content: React.ReactElement = <></>
   const { data, isLoading, isPending, isError } = useAllCourseDocuments()
   const documentData = useMemo(() => {
      if (data && (!isLoading || !isPending)) {
         return createDocuments(data)
      }
      return null
   }, [data])

   if (isLoading || (isPending && !documentData)) {
      content = <CoursesTableSkeleton />
   } else if (documentData) {
      content = <DataTable columns={columns} data={documentData} DataTableToolbar={DataTableToolbar} />
   }

   return (
      <div className="flex flex-col h-full w-full justify-center items-center ">
         <div className="w-full pt-4">{content}</div>
      </div>
   )
}
